import _ from 'lodash'
import moment from 'moment'
import DayOptions from '../options/day-options'
import HourOptions from '../options/hour-options'
import MinuteOptions from '../options/minute-options'
import TimeSlot from '../models/time-slot'
import Range from '../models/range'
import Time from '../models/time'

function to(slots) {
    return slots.map(toSlot);
}

function toSlot(slot) {
    return new TimeSlot(
        toSlotDay(slot.day),
        toSlotRange(slot.start, slot.end),
    );
}

function toSlotDay(day) {
    return _.find(DayOptions, { databaseId: day });
}

function toSlotRange(start, end) {
    return new Range(toSlotTime(start), toSlotTime(end))
}

function toSlotTime(time) {
    const duration = moment.duration(time);

    const isMidnight = duration.hours() == 23 && duration.minutes() == 59;

    const hour = isMidnight ? 24 : duration.hours();
    const minute = isMidnight ? 0 : duration.minutes();

    return new Time(
        _.find(HourOptions, { value: hour }),
        _.find(MinuteOptions, { value: minute })
    );
}

function from(slots) {
    return slots.map(fromSlot)
}

function fromSlot(slot) {
    return {
        day: slot.dayDatabaseId(),
        start: fromSlotTime(slot.getStartTime()),
        end: fromSlotTime(slot.getEndTime()),
    };
}

function fromSlotTime(time) {
    const hours = time.isMidnight() ? 23 : time.getHour();
    const minutes = time.isMidnight() ? 59 : time.getMinute();

    const duration = moment.duration({ hours, minutes });

    return moment.utc(duration.asMilliseconds()).format("HH:mm");
}

export default {
    to,
    from
}
